<template>
<div>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0" >
    <template #toggler >
      <CHeaderNavLink >
            <CHeaderNavItem  class="d-md-down-none mx-2">
            <CHeaderNavLink>
            <CIcon name="cil-list"/>
            <span class="badge rounded-pill position-absolute top-0 end-0 bg-info-gradient bg-success">{{MsgLen}}</span>
            </CHeaderNavLink>
        </CHeaderNavItem>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center  c-header-message" color="light">
      <strong>您有{{MsgLen}}個未讀訊息</strong>
    </CDropdownHeader>      
    <CDropdownItem   v-for="(msg, index) in messages" :key="msg.MsgID" @click="showDetailMsg(msg.msgID)">
        <header>
    <div class="inline-block" style=" padding-top: 10px;">  
      <img class="avatar-img" style="height:35px" :src="msg.userImg" :alt="msg.sender" />   
    </div>
    <div class="inline-block" >          
      <div class="inline-block" style="width:120px; padding-left: 5px;">          
        {{ msg.sender }}
      </div>
      <div class="inline-block" style="width:120px; text-align: right;">          
        {{ msg.date }}
      </div>
      <br/>
      <div class="inline-block" style="width: 260px;"> 
            <span v-if="msg.is_import" class="text-danger" style="width: 2em;">&nbsp;❗</span>
            <span v-else class="text-danger" style="width: 2em; visibility: hidden;">&nbsp;  </span>
            <span style="white-space: normal; word-wrap: break-word;">{{ msg.title }}</span>
      </div>
      <br/>

    </div>    
  </header>
  <CDropdownDivider v-if="index < messages.length - 1" />
</CDropdownItem>

    <div class="p-2"> <a class="btn btn-outline-primary w-100" href="#" @click="gotoMsg" data-coreui-i18n="viewAllMessages">檢視所有訊息</a></div>
    <!--div class="d-flex">
                    <div class="avatar flex-shrink-0 my-3 me-3"><img class="avatar-img" src="assets/img/avatars/1.jpg" alt="user@email.com"><span class="avatar-status bg-success"></span></div>
                    <div class="message text-wrap">
                      <div class="d-flex justify-content-between mt-1">
                        <div class="small text-body-secondary">Jessica Williams</div>
                        <div class="small text-body-secondary">Just now</div>
                      </div>
                      <div class="fw-semibold"><span class="text-danger">! </span>Urgent: System Maintenance Tonight</div>
                      <div class="small text-body-secondary">Attention team, we'll be conducting critical system maintenance tonight from 10 PM to 2 AM. Plan accordingly...</div>
                    </div>
                  </div>-->
    <!--<div v-for="(item, value) in datas" :key="value">
      <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>{{ item.name }}</strong>
      </CDropdownHeader>      
      <div v-for="(item_v, value_v) in item.datas" :key="value_v">      
        <CDropdownItem @click="urlframe(item_v.url)">      
          <div style="padding-left:5px;" width="30%"><img :src="item_v.img" width="48"/></div>
          <div style="padding-left:15px;" width="70%"><b>{{item_v.title}}</b><br/><span>{{item_v.content}}</span></div>
        </CDropdownItem>
      </div>
    </div>-->
  </CDropdown>
  <div class="control-section">
    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' width='80%' height='80%'>  
        <iframe id="myFrame" style="width:100%; height:100%" :src="this.url_action" frameborder="no" ref="iframe" ></iframe>
    </ejs-dialog>        
  </div>
</div>
</template>

<script>
import Vue from "vue";
import { DialogPlugin } from '@syncfusion/ej2-vue-popups';  
Vue.use(DialogPlugin);
export default {
  name: 'TheHeaderDropdownList',
  data () {
    return { 
       messages: [
      // 可再加更多訊息...
    ],
      MsgLen:0,
      itemsCount: 42,
      user_data: "",
      url_action: "",
      datas: [],
      timer: null
    }
  },
   methods: { 
  
      //api
      getMsg: function () {  
          this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Message/My/Header`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.showMsg(response.data.msg) ;return; }                 
            this.messages = response.data.datas;
            this.MsgLen =response.data.datas.length;
            return; 
          })
          .catch((error) => { 
            this.showMsg(error) 
          })             
        },
      urlframe: function(url) {
        // console.log(url)
        this.url_action = url;
        this.$refs.modalDialog.show();
      },

      showDetailMsg: function(key) {
        this.$router.push(`/system/mymessage?msgID=${key}`);
      },
      gotoMsg: function() {
        this.$router.push('/system/mymessagelist');  
      },
      showMsg: function() {
        // this.$router.push('/system/mymessagelist');  
      },

    },
    created() {      
      this.getMsg();
      this.timer = window.setInterval(( () => this.getMsg() ), 10000);  // TODO
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }  

}

</script>
<style scoped>
  .c-header-message {
    min-width: 20rem;
  }
 .c-icon {
    margin-right: 0.3rem;
  }

  .avatar-status {
    position: absolute;
    bottom: 0;
    display: block;
    border: 1px solid #fff;
    border-radius: 50em;
    width: 15px;
    height: 15px;
    right: 0px;
  } 


  header {
    display: block;
    width: 300px;
    min-height: 30px;
  }

  .inline-block {
     display: inline-block;
     text-overflow: ellipsis; 
     white-space: nowrap; 
     overflow:hidden;
 
     -webkit-box-orient: vertical; 
     text-overflow:hidden;
}

</style>